import React, { useEffect, useState } from "react";
import { Link, Route, Routes, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { KnowledgeProvider, useKnowledge } from "../lib/knowledge.jsx";
import { fmtDay } from "../lib/knowledgeApi";
import TopicTree from "../components/knowledge/TopicTree";
import KnowledgeHome from "../components/knowledge/KnowledgeHome";
import TopicPage from "../components/knowledge/TopicPage";
import { GlossaryPage, SearchPage, TagPage } from "../components/knowledge/Lookups";

function MobileTree() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  useEffect(() => setOpen(false), [pathname]);
  return (
    <div className="lg:hidden mb-5 flex items-center justify-between gap-3">
      <Link to="/learn" className="font-display font-semibold text-[15px]" data-testid="kc-mobile-home">Knowledge Center</Link>
      <button data-testid="kc-mobile-topics" onClick={() => setOpen(true)} className="inline-flex items-center gap-1.5 h-9 px-3 border border-border rounded-sm text-[12.5px] bg-surface-2"><Menu size={14} />Topics</button>
      {open && (
        <div className="fixed inset-0 z-50" data-testid="kc-mobile-drawer">
          <div className="absolute inset-0 bg-black/60 animate-fade-in" onClick={() => setOpen(false)} />
          <div className="absolute inset-y-0 left-0 w-[86%] max-w-[340px] bg-surface border-r border-border p-4 overflow-y-auto animate-slide-in-right">
            <button data-testid="kc-mobile-close" aria-label="Close topics" onClick={() => setOpen(false)} className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center rounded-sm hover:bg-surface-2"><X size={15} /></button>
            <TopicTree onPick={() => setOpen(false)} />
          </div>
        </div>
      )}
    </div>
  );
}

function BuildFooter() {
  const { index } = useKnowledge();
  if (!index?.build) return null;
  return (
    <footer data-testid="kc-build-footer" className="mt-14 pt-4 border-t border-border flex flex-wrap items-center gap-x-4 gap-y-1 text-[11.5px] text-muted font-mono-tabular">
      <span>1Rotary Control Tower · Knowledge Center</span>
      <span data-testid="kc-build-number">{index.build.label}</span>
      <span data-testid="kc-build-updated">Last updated {fmtDay(index.build.updated)}</span>
      <span>{index.total} topics</span>
    </footer>
  );
}

// Hidden learning module: not in the sidebar, opened from the top-bar help button or a direct /learn link.
export default function KnowledgeCenter() {
  return (
    <KnowledgeProvider>
      <div data-testid="knowledge-center" className="grid grid-cols-1 lg:grid-cols-[250px_minmax(0,1fr)] gap-8 xl:gap-12">
        <aside className="hidden lg:block">
          <div className="sticky top-28 max-h-[calc(100vh-8rem)] overflow-y-auto pr-2 -mr-2 pb-6 kc-scroll"><TopicTree /></div>
        </aside>
        <div className="min-w-0">
          <MobileTree />
          <Routes>
            <Route index element={<KnowledgeHome />} />
            <Route path="search" element={<SearchPage />} />
            <Route path="glossary" element={<GlossaryPage />} />
            <Route path="tag/:tag" element={<TagPage />} />
            <Route path=":slug" element={<TopicPage />} />
          </Routes>
          <BuildFooter />
        </div>
      </div>
    </KnowledgeProvider>
  );
}
